import { CommonHttpHelper, NO_DATA_MESSAGE } from '@usas/ui-web/utils/HttpHelper';

const GetRecordListData = (isTopInfoLaneSheet, isRightInfoLaneSheet, state, setState) => {
  if (state.isArrayLoading !== true && !state.message) {
    const newState = {
      ...state,
      isArrayLoading: true,
      isArrayLoaded: false,
      isTopInfoLaneSheet,
      isRightInfoLaneSheet,
      message: 'Loading...'
    };
    setState(newState);

    const url = `/RecordList?isTopInfoLaneSheet=${isTopInfoLaneSheet}&isRightInfoLaneSheet=${isRightInfoLaneSheet}`;
    CommonHttpHelper(url, 'GET')
      .then((arrayData) => {
        if (!arrayData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            isArrayLoading: false,
            isArrayLoaded: true,
            arrayData,
            isTopInfoLaneSheet,
            isRightInfoLaneSheet,
            items: arrayData.map(x => { return { id: x.recordListId, name: x.listName } }),
            message: ''
          })
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isArrayLoading: false,
          isArrayLoaded: false,
          message: message
        });
      });
  }
};

export default GetRecordListData;